import useResetPasswordMail from "./useResetPasswordMail";
import CrudModuleFactoryModal from "@beeldit/core/components/CrudModuleFactoryModal";
import usePrepareResetPassword from "@main/producers/actions/reset-password-mail/usePrepareResetPassword";
import {useContext} from "react";
import {ResetPasswordActionContext} from "@main/producers/actions/reset-password-mail/ResetPasswordActionContext";
import {t} from "i18next";

function useResetPasswordMailAction(): any {
  const prepareResetPassword = usePrepareResetPassword();
  const prepareResetPasswordFunction = (email: string) => prepareResetPassword(email);

  const onSuccess = () => {
    setShowModal(false);
  };

  const resetPassword = useResetPasswordMail();
  const resetPasswordFunction = () => resetPassword(onSuccess);

  const contextInstance = useContext(ResetPasswordActionContext);
  const { setShowModal } = contextInstance;


  const modalConfig = {
    contextInstance: contextInstance,
    title: "reset_password_email",
    onSubmit: () => resetPasswordFunction(),
  };

  const actionTemplate = (
      <CrudModuleFactoryModal modalConfig={modalConfig}>
        <p>{t('are_you_sure_you_want_to_send_password_reset_email')}</p>
      </CrudModuleFactoryModal>
  );

  return {
    prepareResetPasswordFunction,
    actionTemplate
  };
}

export default useResetPasswordMailAction;
